"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
function shouldBeOneOf(options) {
    return function (value) {
        var result = options.includes(value);
        if (!result) {
            console.error.apply(console, __spreadArrays(['The value received was `', value, '`, but one of these were expected:\n'], options.map(function (item) { return "- " + item + "\n"; })));
        }
        return result;
    };
}
exports.default = shouldBeOneOf;
//# sourceMappingURL=shouldBeOneOf.js.map